var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3,
    fill: "#1FAB89"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 10.6875C11.6519 10.6875 11.3181 10.8258 11.0719 11.0719C10.8258 11.3181 10.6875 11.6519 10.6875 12C10.6875 12.3481 10.8258 12.6819 11.0719 12.9281C11.3181 13.1742 11.6519 13.3125 12 13.3125C12.3481 13.3125 12.6819 13.1742 12.9281 12.9281C13.1742 12.6819 13.3125 12.3481 13.3125 12C13.3125 11.6519 13.1742 11.3181 12.9281 11.0719C12.6819 10.8258 12.3481 10.6875 12 10.6875Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0002 8.20837C10.473 8.20837 9.09983 8.82146 8.1105 9.58096C7.61466 9.96129 7.20808 10.3836 6.92283 10.7943C6.64283 11.198 6.4585 11.6215 6.4585 12C6.4585 12.3786 6.64341 12.8021 6.92283 13.2052C7.20866 13.6165 7.61466 14.0388 8.1105 14.4185C9.09983 15.1792 10.473 15.7917 12.0002 15.7917C13.5273 15.7917 14.9005 15.1786 15.8898 14.4191C16.3857 14.0388 16.7922 13.6165 17.0769 13.2058C17.3569 12.8021 17.5418 12.3786 17.5418 12C17.5418 11.6215 17.3569 11.198 17.0769 10.7949C16.7922 10.3836 16.3857 9.96129 15.8898 9.58154C14.9005 8.82087 13.5273 8.20837 12.0002 8.20837ZM9.81266 12C9.81266 11.4199 10.0431 10.8635 10.4534 10.4532C10.8636 10.043 11.42 9.81254 12.0002 9.81254C12.5803 9.81254 13.1367 10.043 13.547 10.4532C13.9572 10.8635 14.1877 11.4199 14.1877 12C14.1877 12.5802 13.9572 13.1366 13.547 13.5468C13.1367 13.9571 12.5803 14.1875 12.0002 14.1875C11.42 14.1875 10.8636 13.9571 10.4534 13.5468C10.0431 13.1366 9.81266 12.5802 9.81266 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye-icon.a99c6f6d1901975a2a1113d09d6f77d9.svg";
export { ForwardRef as ReactComponent };